import { render } from "./TermLinkList.vue?vue&type=template&id=08c42352&ts=true"
import script from "./TermLinkList.vue?vue&type=script&lang=ts"
export * from "./TermLinkList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__